<section class="example-container">
  <div [ngTemplateOutlet]="selected ? selected.content : null"></div>
</section>